/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState, useMemo } from 'react';
import { FaChevronDown, FaChevronUp, FaCog } from 'react-icons/fa';
import { useLazyQuery } from 'react-apollo';
import { useHistory, Link } from 'react-router-dom';
import gql from 'graphql-tag';
import classnames from 'classnames';
import './styles.scss';
import useMe from '../../hooks/useMe';
import firebase from '../../services/firebase';
import useContext from '../../hooks/useContext';

const myCondominiumsGql = gql`
  query myCondominiums {
    myCondominiums {
      role
      confirmed
      data {
        _id
        name
      }
    }
  }
`;

export default function ChangeCondominiumWidget() {
  const history = useHistory();
  const [me, fetchMe] = useMe({ fetchPolicy: 'cache-first' });
  const { write, condominium, isJanitor } = useContext();

  const changeCondominium = async condominiumId => {
    if (condominiumId !== condominium._id) {
      write({ condominiumId });
    }
  };

  const [isOpen, setOpen] = useState(false);
  const [fetchMyCondominiums, { data }] = useLazyQuery(myCondominiumsGql, {
    fetchPolicy: 'network-only',
  });
  const logout = () => {
    firebase
      .auth()
      .signOut()
      .then(() => {
        history.push('/');
      });
  };

  const condominiums = useMemo(() => {
    if (!data) return [];
    return data && data.myCondominiums && data.myCondominiums;
  }, [data]);

  useEffect(() => {
    fetchMe();
    if (me) fetchMyCondominiums();
  }, []);

  const onClickEdit = ({ data: condominiumItem, role }) => {
    if (role === 'dweller') return;

    history.push(`/condominiums/${condominiumItem._id}/dwellers`);
  };

  return (
    <div className={`change-condominium-widget ${isOpen && 'open'}`}>
      <div className="holder">
        <button type="button" onClick={() => setOpen(open => !open)}>
          {condominium.name}
          {isOpen ? <FaChevronUp /> : <FaChevronDown />}
        </button>

        {isOpen && (
          <>
            {condominiums.map(condominiumItem => (
              <div key={condominiumItem.data._id} className="d-flex justify-content-between condominium-item">
                <button
                  className="btn btn-clear w-100 text-left"
                  type="button"
                  onClick={() => {
                    setOpen(open => !open);
                    changeCondominium(condominiumItem.data._id);
                  }}
                >
                  {condominiumItem.data.name}
                </button>

                <span
                  className={classnames('badge', condominiumItem.role === 'janitor' ? 'badge-extra' : 'badge-primary')}
                  onClick={() => onClickEdit(condominiumItem)}
                >
                  {condominiumItem.role === 'janitor' && <FaCog />}
                  {condominiumItem.role === 'janitor' ? ' Síndico' : 'Condômino'}
                </span>
              </div>
            ))}
            {isJanitor && (
              <Link className="btn btn-primary btn-block" type="button" to="/condominiums/new">
                + adicionar condomínio
              </Link>
            )}
            {!isJanitor && (
              <>
                É síndico em outro condomínio e quer criar sua assembleia?
                <Link className="btn btn-outline-primary btn-block mt-2" type="button" to="/condominiums/new">
                  Cadastrar condomínio
                </Link>
              </>
            )}
            <button className="btn btn-sm text-primary mt-3" type="button" onClick={logout}>
              <b> Sair</b>
            </button>
          </>
        )}
      </div>
    </div>
  );
}
